import React from 'react'
import { CheckboxGroup, Grid, csx, useBreakpoint } from '@vtex/admin-ui'
import { useFragment } from 'react-relay-offline'
import { graphql } from 'babel-plugin-relay/macro'

import { AssemblyItemSelectNone } from './AssemblyItemSelectNone'
import type { AssemblyItemsListGroup_ProductSkuAssemblyItemComposition$key } from './__generated__/AssemblyItemsListGroup_ProductSkuAssemblyItemComposition.graphql'
import { AssemblyItemSelect } from './AssemblyItemSelect'

type AssemblyItemsListGroupProps = {
  assemblyItemComposition: AssemblyItemsListGroup_ProductSkuAssemblyItemComposition$key
  currentAssemblyItemId: string
  displayName: string
}

export const AssemblyItemsListGroup = ({
  assemblyItemComposition,
  currentAssemblyItemId,
  displayName,
}: AssemblyItemsListGroupProps) => {
  const assemblyItemGroup = useFragment<AssemblyItemsListGroup_ProductSkuAssemblyItemComposition$key>(
    graphql`
      fragment AssemblyItemsListGroup_ProductSkuAssemblyItemComposition on ProductSkuAssemblyItemComposition {
        minQuantity
        maxQuantity
        items {
          edges {
            node {
              id
              sku {
                sellers {
                  edges {
                    node {
                      _id
                    }
                  }
                }
              }
              ...AssemblyItemSelect_ProductSkuAssemblyItemCompositionItem
            }
          }
        }
      }
    `,
    assemblyItemComposition
  )

  const { breakpoint } = useBreakpoint()
  const isMobile = breakpoint === 'mobile'

  const showWithoutOption =
    assemblyItemGroup.minQuantity === 0 && assemblyItemGroup.maxQuantity === 1

  return (
    <CheckboxGroup
      label=""
      className={csx({
        paddingY: '$space-6',
        '> div': {
          '> div': {
            display: 'block',
            '> div': {
              '> div': {
                display: 'block',
              },
            },
          },
        },
      })}
    >
      <Grid
        templateColumns={`${isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'}`}
        className={csx({ gap: '1.5rem' })}
      >
        {showWithoutOption && (
          <AssemblyItemSelectNone
            currentAssemblyItemId={currentAssemblyItemId}
            displayName={displayName}
            minQuantity={assemblyItemGroup.minQuantity}
            maxQuantity={assemblyItemGroup.maxQuantity}
          />
        )}
        {assemblyItemGroup?.items.edges.map((assemblySku) => {
          const seller = assemblySku.node.sku.sellers.edges.map(
            (sellerSku) => sellerSku.node._id
          )

          return (
            <AssemblyItemSelect
              key={assemblySku.node.id}
              currentAssemblyItemId={currentAssemblyItemId}
              minQuantity={assemblyItemGroup.minQuantity}
              maxQuantity={assemblyItemGroup.maxQuantity}
              isRadioInput={assemblyItemGroup.maxQuantity === 1}
              sellerId={seller[0]}
              productSkuAssemblyItemCompositionItem={assemblySku.node}
            />
          )
        })}
      </Grid>
    </CheckboxGroup>
  )
}
